import { AdminAppState } from '../state/app';
import { Middleware } from 'redux';
import WindowMessenger from '@robotsnacks/window-messenger';
import { setPageContent } from '../actions/page';

const findPageKey = (state: AdminAppState, pageId: string) => {
  if (state.pages[pageId]) {
    return pageId;
  }
  for (const [key, entry] of Object.entries(state.pages)) {
    if (key === pageId) {
      return key;
    } else if (entry.page.id === pageId) {
      return key;
    }
  }
};

export const pageChangeMiddleware = (): Middleware => store => {
  const messenger = new WindowMessenger({
    allowedOrigins: /.*/,
    // TODO: better!
    target: () => {
      const frame = document.getElementById('viewport') as HTMLIFrameElement;
      if (frame) {
        return frame.contentWindow as any;
      }
    },
  });

  messenger.on('page:change', ({ pageId, value }: any) => {
    const pageKey = findPageKey(store.getState(), pageId);
    if (pageKey) {
      store.dispatch(setPageContent(pageKey, value));
    }
  });

  return next => action => {
    return next(action);
  };
};
